import React from 'react';

interface BootstrapIconProps {
  icon: string; // Icon name without 'bi-' prefix (e.g., 'house-door', 'heart-fill')
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

/**
 * BootstrapIcon component to use Bootstrap Icons with Ant Design
 * @param icon - Icon name without 'bi-' prefix (e.g., 'house-door', 'heart-fill')
 * @param size - Font size for the icon
 * @param color - Color of the icon
 * @param className - Additional CSS classes
 * @param style - Additional inline styles
 * @param onClick - Click handler
 *
 * @example
 * <BootstrapIcon icon="house-door" size={24} color="blue" />
 * <BootstrapIcon icon="heart-fill" size="2rem" />
 * <Button icon={<BootstrapIcon icon="save" />}>Save</Button>
 */
const BootstrapIcon: React.FC<BootstrapIconProps> = ({
  icon,
  size,
  color,
  className = '',
  style = {},
  onClick
}) => {
  const iconStyle: React.CSSProperties = {
    fontSize: typeof size === 'number' ? `${size}px` : size,
    color,
    ...style
  };

  return (
    <i
      className={`bi bi-${icon} ${className}`}
      style={iconStyle}
      onClick={onClick}
    />
  );
};

export default BootstrapIcon;

